export function getDemoCredentials(locale) {
  if (locale === "pl") {
    return {
      email: process.env.VUE_APP_DEMO_USER_LOGIN_PL || "",
      password: process.env.VUE_APP_DEMO_USER_PASS_PL || ""
    };
  } else {
    return {
      email: process.env.VUE_APP_DEMO_USER_LOGIN_EN || "",
      password: process.env.VUE_APP_DEMO_USER_PASS_EN || ""
    };
  }
}
